import React, { Component } from 'react'

interface ErrorBoundaryProps {
  children: JSX.Element
}

interface ErrorBoundaryState {
  hasError: boolean
}

export default class extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false
  }

  public static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[ErrorBoundary] Error:', error)
    console.error('[ErrorBoundary] Stack:', errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      return <h1>An error has ocurred!</h1>
    }

    return this.props.children
  }
}
